import {lazy} from 'react'

export const ArchivedRostersHandler = lazy(
  () => import('./../../../../roster/components/rosters/archived-roster-handler')
)

export const LoginCardHandler = lazy(() => import('./../../../../common/components/login-cards'))

export const RostersHandler = lazy(() => import('./../../../../roster/components/rosters'))

export const RosterStudentEditPageHandler = lazy(
  () => import('../../../../roster/components/rosters/student-edit-page')
)

export const AddCoursePageHandler = lazy(
  () => import('../../../../roster/course-page/components/add-course-page-handler')
)

export const EditCoursePageHandler = lazy(
  () => import('../../../../roster/course-page/components/edit-course-page-handler')
)
